// components/Tables/ReusableTable.jsx
import React from 'react'

export const ReusableTable = ({
  dataHeader,
  dataFooter,
  dataBody = [],
  headerClassNames = [],
  footerClassNames = [],
  cellClassNames = [],
  children,
  ...props
}) => {
  return (
    <table {...props} className={`custom-table ${props.className || ''}`}>
      <thead>
        <tr>
          {dataHeader.map((label, idx) => (
            <th
              key={idx}
              className={`custom-table-header ${headerClassNames[idx] || ''}`}
            >
              {label}
            </th>
          ))}
        </tr>
      </thead>

      {children ? (
        <tbody >{children}</tbody>
      ) : (
        <tbody>
          {dataBody.map((row, rIdx) => (
            <tr key={rIdx}>
              {row.map((cell, cIdx) => (
                <td
                  key={cIdx}
                  className={`custom-table-row-body ${cellClassNames[cIdx] || ''}`}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      )}
      {dataFooter && (
        <tfoot>
          <tr>
            {dataFooter.map((label, idx) => (
              <td key={idx} className={footerClassNames[idx] || ''}>
                {label}
              </td>
            ))}
          </tr>
        </tfoot>
      )}
    </table>
  )
}
